var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mx-1 text-center bg-light-primary"},[_c('h4',[_vm._v("Next Queue Number")]),_c('h1',{staticClass:"mt-auto font-weight-bolder"},[_vm._v(" "+_vm._s(_vm.currentQueueMeta.current_queue +1 || 0)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }